<template>
    <div>
        <div class="payment_info_cards_wrpr">
            <div class="billing_payment_info_card current_plan">
	            <v-spinner v-if="loadingDetails"></v-spinner>
	            <div v-else-if="details.status==='active'">
		            <h3 class="card_header_title">Current subscription plan</h3>
		            <div class="card_price"><sup>$</sup>{{ details.next_payment_amount }} <sub>{{ details.plan_type }}</sub></div>
		            <h3 class="plan_name">{{ details.plan_name }}</h3>
		            <div class="layout-row">
			            <v-button @click="$router.push('/settings/billing/choose-your-plan')">Change plan</v-button>
		            </div>
	            </div>
	            <div v-else>
		            <h3 class="card_header_title">Current subscription plan</h3>
		            <div style="">
			            <div class="card_price"><sup>$</sup>0.00</div>
			            <h3 class="plan_name layout-row" style="color: red;">
	                  <span class="warning_icon" style="margin-right: 5px;">
	                      <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
	                          <path d="M19.5941 14.5235L12.5212 1.50247C11.9874 0.603796 11.0445 0.0670776 9.99924 0.0670776C8.95392 0.0670776 8.01111 0.603796 7.47728 1.50247C7.47326 1.50934 7.46986 1.51622 7.46584 1.52309L0.416462 14.5029C-0.128812 15.4205 -0.139124 16.5225 0.388376 17.4504C0.917087 18.3789 1.86959 18.9328 2.93783 18.9328H17.0216C18.0898 18.9328 19.0815 18.3789 19.6101 17.4504C20.1376 16.5225 20.1274 15.4205 19.5941 14.5235ZM8.82619 6.02915C8.82619 5.38126 9.35138 4.8561 9.99924 4.8561C10.6471 4.8561 11.1723 5.3813 11.1723 6.02915V10.7214C11.1723 11.3692 10.6471 11.8944 9.99924 11.8944C9.35138 11.8944 8.82619 11.3691 8.82619 10.7214V6.02915ZM9.99924 16.5867C9.02896 16.5867 8.23963 15.7974 8.23963 14.8271C8.23963 13.8568 9.02892 13.0675 9.99924 13.0675C10.9695 13.0675 11.7588 13.8568 11.7588 14.8271C11.7588 15.7974 10.9695 16.5867 9.99924 16.5867Z" fill="#FDCC5E"/>
	                      </svg>
	                  </span> &nbsp;
				            <span>No plan selected yet!</span>
			            </h3>
		            </div>
		            <div class="layout-row">
			            <v-button @click="$router.push('/settings/billing/choose-your-plan')">Select a plan</v-button>
		            </div>
	            </div>
            </div>

            <div class="billing_payment_info_card next_payment">
	            <v-spinner v-if="loadingDetails"></v-spinner>
	            <template v-else-if="isActive">
		            <h3 class="card_header_title">Next payment</h3>
		            <div class="card_price"><sup>$</sup>{{ details.next_payment_amount }}</div>
<!--		            <div class="next_payment_data">on {{ next_payment_date }}</div>-->
		            <div class="next_payment_data_bottom margin-b-10">In {{daysLeft}}</div>
		            <div class="layout-row">
			            <v-button @click="CancelSubscriptionOpen = true" border>Stop my subscription</v-button>
		            </div>
	            </template>
	            <template v-else>
		            <h3 class="card_header_title">Next payment</h3>
		            <div class="card_price"><sup>$</sup>0.00</div>
		            <div class="next_payment_data_bottom margin-b-10">In 0 days</div>
		            <div class="layout-row">
			            <v-button disabled border>Stop my subscription</v-button>
		            </div>
	            </template>
              <img :src="require('@/assets/img/billing/New_Subscription_big_icon.svg')" alt="" class="bg_img">
            </div>
            <div class="billing_payment_info_card payment_info">
                <h3 class="card_header_title">Payment Information</h3>

                <!-- card_yellow_state card_red_state card_red_state -->
                <div class="payment_card_info_box"
                     :class="{'card_red_state':!isActive }">
                  <span class="warning_icon" v-if="!isActive">
                      <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M19.5941 14.5235L12.5212 1.50247C11.9874 0.603796 11.0445 0.0670776 9.99924 0.0670776C8.95392 0.0670776 8.01111 0.603796 7.47728 1.50247C7.47326 1.50934 7.46986 1.51622 7.46584 1.52309L0.416462 14.5029C-0.128812 15.4205 -0.139124 16.5225 0.388376 17.4504C0.917087 18.3789 1.86959 18.9328 2.93783 18.9328H17.0216C18.0898 18.9328 19.0815 18.3789 19.6101 17.4504C20.1376 16.5225 20.1274 15.4205 19.5941 14.5235ZM8.82619 6.02915C8.82619 5.38126 9.35138 4.8561 9.99924 4.8561C10.6471 4.8561 11.1723 5.3813 11.1723 6.02915V10.7214C11.1723 11.3692 10.6471 11.8944 9.99924 11.8944C9.35138 11.8944 8.82619 11.3691 8.82619 10.7214V6.02915ZM9.99924 16.5867C9.02896 16.5867 8.23963 15.7974 8.23963 14.8271C8.23963 13.8568 9.02892 13.0675 9.99924 13.0675C10.9695 13.0675 11.7588 13.8568 11.7588 14.8271C11.7588 15.7974 10.9695 16.5867 9.99924 16.5867Z" fill="#FDCC5E"/>
                      </svg>
                  </span>
                  <div v-else-if="details.card_type==='mastercard'" class="card_type_icon">
                      <img :src="require('@/assets/img/billing/mastercard.svg')" alt="">
                  </div>
	                <div v-else class="card_type_icon">
		                <img :src="require('@/assets/img/billing/visa_logo.svg')" alt="">
	                </div>
	                <v-spinner v-if="loadingDetails"></v-spinner>
	                <div v-else-if="details.card_type && details.card_number" class="card_text_info" >
                      <div class="number" style="text-transform: uppercase;">
                        {{ details.card_type }} **** **** **** {{ details.card_number }}
                      </div>
                      <div class="expired">{{ details.card_description }}</div>
                  </div>
                </div>
	            <div class="layout-row">
		            <v-button border @click="selectPaymentMethodPopup = true">Update billing details</v-button>
	            </div>
            </div>
        </div>

        <div class="panel">
            <div class="panel-head panel_table_head">
                <h2>Payment history</h2>
            </div>
            <div class="panel_table_wrpr" style="position: relative;">
	              <v-spinner v-if="loadingCharges" />
                <table v-else class="panel_table entries-table">
                    <thead>
                        <tr>
                            <th>Date</th>
<!--                            <th>ID Number</th>-->
                            <th>Status</th>
                            <th>Payment method</th>
                            <th>Amount</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="entry" v-for="(charge,index) in charges">
                            <td><span class="gray_light_text">{{ formatDate(charge.created) }}</span></td>
<!--                            <td><b>{{ // charge.id }}</b></td>-->
                            <td>
	                            <span v-if="charge.status==='succeeded'" class="info_xs_badge paid">
	                              <img :src="require('@/assets/img/billing/paid_icon.svg')" alt="">
	                              Paid
                              </span>
                              <span v-else class="info_xs_badge pending" style="text-transform: capitalize">
                                  <img :src="require('@/assets/img/billing/panding_icon.svg')" alt="">
                                  {{ charge.status }}
                              </span>
                            </td>
                            <td>{{ charge.payment_method_details.card.brand.toUpperCase() }} <b>{{ charge.payment_method_details.card.last4 }}</b></td>
                            <td><b>$ {{  parseFloat((charge.amount/100)+'').toFixed(2) }}</b></td>
                            <td>
                                <div class="btns_wrpr">
                                    <a class="btn brdr_btn xs_btn_with_icon receipt-btn"
                                    :href="charge.receipt_url" target="_blank">
                                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.125 12.375H11.875C12.0408 12.375 12.1997 12.4408 12.3169 12.5581C12.4342 12.6753 12.5 12.8342 12.5 13C12.5 13.1658 12.4342 13.3247 12.3169 13.4419C12.1997 13.5592 12.0408 13.625 11.875 13.625H3.125C2.95924 13.625 2.80027 13.5592 2.68306 13.4419C2.56585 13.3247 2.5 13.1658 2.5 13C2.5 12.8342 2.56585 12.6753 2.68306 12.5581C2.80027 12.4408 2.95924 12.375 3.125 12.375ZM8.125 8.73438L10.1519 6.70813L11.0356 7.59188L7.5 11.1275L3.96437 7.59188L4.84812 6.70813L6.875 8.73438V1.75H8.125V8.73438Z" fill="#4368E0" />
                                        </svg>
                                        <span class="label">Receipt</span>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="load_more_btn_wrpr" v-if="false">
                <a class="load_more_btn">
                    Load more
                    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.83366 9.49992C0.83366 4.43731 4.93772 0.333252 10.0003 0.333252C15.0629 0.333252 19.167 4.43731 19.167 9.49992C19.167 14.5625 15.0629 18.6666 10.0003 18.6666C4.93772 18.6666 0.83366 14.5625 0.83366 9.49992ZM2.50033 9.49992C2.50033 13.6421 5.85819 16.9999 10.0003 16.9999C14.1425 16.9999 17.5003 13.6421 17.5003 9.49992C17.5003 5.35778 14.1425 1.99992 10.0003 1.99992C5.85819 1.99992 2.50033 5.35778 2.50033 9.49992ZM9.16699 10.8214V5.33325H10.8337V10.8214L12.7444 8.91066L13.9229 10.0892L10.0003 14.0118L6.07774 10.0892L7.25625 8.91066L9.16699 10.8214Z" fill="#4368E0" />
                    </svg>
                </a>
            </div>
        </div>

	    <cancel-subscription-popup v-if="CancelSubscriptionOpen" @close="CancelSubscriptionOpen=false" @stop="subStopped" />

	    <update-payment-method-popup v-if="selectPaymentMethodPopup" @close="selectPaymentMethodPopup=false" />

    </div>
</template>

<script>
import VButton from "@/components/base/v-button";
import API from '@/api';
import VSpinner from "@/components/base/v-spinner";
import Loading from "@/components/Loading";
import moment from 'moment'
import CancelSubscriptionPopup from "@/views/settings/billing/cancel-subscription-popup";
import store from '@/store';
import UpdatePaymentMethodPopup from "@/views/settings/billing/UpdatePaymentMethod";

export default {
	components: {
		UpdatePaymentMethodPopup,
		CancelSubscriptionPopup,
		Loading,
		VSpinner,
    VButton,
  },
	mixins:[API],
  data() {
    return {
	    CancelSubscriptionOpen: false,
    	loadingDetails: true,
    	details: {
	    	status: "active",
    		plan_key: "funnelish-apps",
		    plan_name:  "Funnelish Apps",
		    plan_description: "Funnelish Apps for Clickfunnels",
		    plan_price: 29,
		    plan_type: 'monthly',
		    currency: "USD",
		    next_payment_amount:  144,
		    next_payment_date:  "2021-05-11T17:40:10+01:00",
		    card_type:  "MasterCard",
		    card_number:  "4969",
		    card_description: "MasterCard prepaid card",
	    },
	    loadingCharges: false,
	    charges: [],
      changePlanPopupOpen: false,
      selectPaymentMethodPopup: false,
    }
  },
	computed: {
		isActive() {
			return this.details.status==='active' && !!this.details.card_type && !!this.details.card_number;
		},
		daysLeft(){
			var m = moment(this.details.next_payment_date);
			var today = moment().startOf('day');
			var days = Math.round(moment.duration(m - today).asDays());

			if (days > 30) {
				let months = Math.round(moment.duration(m - today).asMonths());
				return months + " months";
			}
			return days + " days";
		},
		next_payment_date() {
			return  moment(this.details.next_payment_date).format('MMMM Do, YYYY');
		},
		userInfo() {
			return this.$store.state.userInfo;
		},
	},
	methods: {
		subStopped(newSub) {
			this.CancelSubscriptionOpen = false;
			this.loadDetails();
		},
		formatDate(date) {
			return  moment.unix(date).format('MMMM DD, YYYY');
		},
		changeStep(stepNumber){
      this.$emit('changeStep', stepNumber);
    },
    closeChangePlanPopup(){
      this.changePlanPopupOpen = false;
    },
    closePaymentMethodPopup(){
      this.selectPaymentMethodPopup = false;
    },
		async loadCharges() {
			try {
				this.charges = [];
				this.loadingCharges = true;
				this.charges = await this.api.billing.getCharges()
			} catch (e) {
				this.$error(e)
			} finally {
				this.loadingCharges = false;
			}
		},
		async loadDetails() {
    	try {
    		this.loadingDetails = true;
		    this.details = {};
		    this.details = await this.api.billing.getBillingDetails();
		    if (this.details.status !== "active" && this.$route.path==='/settings/billing') {
		    	await this.$router.push("/settings/billing/choose-your-plan")
		    }
	    } catch (e) {
    		this.$error(e)
	    } finally {
		    this.loadingDetails = false;
	    }
		},
	},
	async created(){
		let isSubActive = async () => {

			// FIXME: avoid loading this again! should be loaded by App.vue already but it's async.
			let user = await this.api.users.me();

			let pkey = user.plan_key;
			if (!pkey || pkey.indexOf('trial') >= 0) return false;

			let expiryS = user.plan_expiry_date;
			if (expiryS) {
				let today = moment((new Date()).toUTCString());
				let expiry = moment(expiryS);
				let daysLeft = expiry.diff(today, 'days', false)+1;

				return (daysLeft > 0)
			} else {
				return true;
			}
		}

		if (!(await isSubActive())) {
			this.$router.replace({path: '/settings/billing/choose-your-plan',})
			// next({path: '/settings/billing/choose-your-plan',});
		} else {
			this.loadDetails()
			this.loadCharges()
		}
	},

};
</script>
<style lang="scss" scoped>
.receipt-btn {
	padding: 4px 10px;
	font-size: 12px;
}
.billing-page .panel_table {
	border-collapse: separate;
	border-spacing: 0 8px;
	tbody tr {
		border-bottom: unset;
	}
}

</style>
<style lang="scss">
.card_price {
	sub {
		font-weight: normal;
		font-size: 18px;
		margin-top: 4px;
		margin-left: 5px;
		color: #c4c7d2;
		text-transform: lowercase;
		vertical-align: bottom;
		line-height: unset;
	}
}
.payment_card_info_box {
	position: relative;
}
.billing_payment_info_card {
	position: relative;
}
</style>
